import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[hideDropdownduttonDIr]'
})
export class hideDropdownButtonDirective {
  @Output('close') onclose = new EventEmitter();
  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    this.onclose.emit(event);
  }
}
